import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";

import "animate.css/animate.css";

const FirstModal = ({
  classes,
  nextQuestion,
  handleClose,
  answeredCorrectly,
  question,
  isOpen
}) => {
  return (
    <Modal open={isOpen}
    className="animate__animated animate__fadeInRight"
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Typography className={classes.stepNumber}>STEP 1</Typography>
          <Grid container justify="center" className={classes.mainLine}>Let’s find out which of our “Friends” are unemployed!</Grid>
          <Grid container justify="center" className={classes.subMainLine}>To calculate the labor force participation rate and the unemployment rate, <br /> we start with the working age population (everyone 16 or over who isn’t in prison or the military) <br />and classify them as either in the labor force or not.</Grid>
          <Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography className={classes.evalDesc}>
            Someone is in the labor force if they are:
              <ul className={classes.evalList}>
                <li style={{ paddingTop: 5, lineHeight:  1.2 }}>An adult working full, part time, and/or <br/>  self-employed</li>
                <li style={{ paddingTop: 5, lineHeight:  1.2 }}>Not employed but who are actively seeking a job (the unemployed)</li>
              </ul>
            </Typography>
            <Typography className={classes.evalDesc}>
            Someone is not in the labor force if they are:
              <ul className={classes.evalList}>
                <li style={{ paddingTop: 5, lineHeight:  1.2 }}>An adult and not actively seeking work, including retirees, homemakers and students</li>
              </ul>
            </Typography>
          </Grid>
          <Grid container justify="center" className={classes.submitButtonDiv}>
            <Button className={classes.submitButton} onClick={handleClose}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(FirstModal);
